import * as React from "react";
import { Dialog } from "@material-ui/core";

export interface IModalConfirmPros {
    children: React.ReactNode,
    open: boolean;
    onClose: () => void;  
    disableBackdropClick?: boolean ;
    disableEscapeKeyDown?: boolean; 
}

export const ConfitmModalRoot:React.FC<IModalConfirmPros> = (props) => { 

    return (
        <>
             <Dialog             
              open={props.open}
              onClose={props.onClose}
              aria-labelledby="share-table-modal-group-dialog-title"
              aria-describedby="share-table-modal-group-dialog-description"
              className="confirm-modal"
              disableBackdropClick={props.disableBackdropClick ? props.disableBackdropClick : false}
              disableEscapeKeyDown={props.disableEscapeKeyDown? props.disableEscapeKeyDown: false}
            >
             {props.children}  
            </Dialog>
        </>
    )
}




// WEBPACK FOOTER //
// ./src/component/shared/confirm-modal/ConfirmModalRoot.tsx